/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssignUserRoleRequestDto } from '../models';
// @ts-ignore
import type { CreateUserRequestDto } from '../models';
// @ts-ignore
import type { PermissionDto } from '../models';
// @ts-ignore
import type { ReplaceUserPermissionGrantsRequestDto } from '../models';
// @ts-ignore
import type { UpdateUserDetailsRequestDto } from '../models';
// @ts-ignore
import type { UserDetailsDto } from '../models';
// @ts-ignore
import type { UserDetailsWithPermissionDto } from '../models';
// @ts-ignore
import type { UserPermissionGrantErrorResponseDto } from '../models';
// @ts-ignore
import type { UserPermissionGrantsDto } from '../models';
// @ts-ignore
import type { UserSearchResponseDto } from '../models';
// @ts-ignore
import type { UserShortDto } from '../models';
// @ts-ignore
import type { UsersSearchRequestDto } from '../models';
/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign a role to the user or remove it
         * @param {string} userId 
         * @param {AssignUserRoleRequestDto} assignUserRoleRequestDto Role assignment request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUserRole: async (userId: string, assignUserRoleRequestDto: AssignUserRoleRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('assignUserRole', 'userId', userId)
            // verify required parameter 'assignUserRoleRequestDto' is not null or undefined
            assertParamExists('assignUserRole', 'assignUserRoleRequestDto', assignUserRoleRequestDto)
            const localVarPath = `/api/users/{userId}/role`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignUserRoleRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create user
         * @param {CreateUserRequestDto} createUserRequestDto Create user request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserRequestDto: CreateUserRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserRequestDto' is not null or undefined
            assertParamExists('createUser', 'createUserRequestDto', createUserRequestDto)
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserDetails', 'userId', userId)
            const localVarPath = `/api/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires ROLE_READ. The user\'s effective permissions are their role\'s permissions plus these grants. 404 codes: USER_NOT_FOUND.
         * @summary Get the additional permissions granted to the user on top of their role
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissionGrants: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserPermissionGrants', 'userId', userId)
            const localVarPath = `/api/users/{userId}/permission-grants`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user short details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShort: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserShort', 'userId', userId)
            const localVarPath = `/api/users/{userId}/short`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users short list
         * @param {PermissionDto} [permission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersShort: async (permission?: PermissionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/short`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get my details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires ROLE_EDIT. The effective permissions change at once, without signing in again. 400 codes: PERMISSION_GRANTS_REQUIRED, PERMISSION_GRANT_UNKNOWN. 404 codes: USER_NOT_FOUND.
         * @summary Replace the additional permissions granted to the user on top of their role
         * @param {string} userId 
         * @param {ReplaceUserPermissionGrantsRequestDto} replaceUserPermissionGrantsRequestDto Additional permissions of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUserPermissionGrants: async (userId: string, replaceUserPermissionGrantsRequestDto: ReplaceUserPermissionGrantsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('replaceUserPermissionGrants', 'userId', userId)
            // verify required parameter 'replaceUserPermissionGrantsRequestDto' is not null or undefined
            assertParamExists('replaceUserPermissionGrants', 'replaceUserPermissionGrantsRequestDto', replaceUserPermissionGrantsRequestDto)
            const localVarPath = `/api/users/{userId}/permission-grants`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceUserPermissionGrantsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search users
         * @param {number} page 
         * @param {number} pageSize 
         * @param {UsersSearchRequestDto} usersSearchRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers: async (page: number, pageSize: number, usersSearchRequestDto: UsersSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchUsers', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchUsers', 'pageSize', pageSize)
            // verify required parameter 'usersSearchRequestDto' is not null or undefined
            assertParamExists('searchUsers', 'usersSearchRequestDto', usersSearchRequestDto)
            const localVarPath = `/api/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user details
         * @param {string} userId 
         * @param {UpdateUserDetailsRequestDto} updateUserDetailsRequestDto User details update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails: async (userId: string, updateUserDetailsRequestDto: UpdateUserDetailsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserDetails', 'userId', userId)
            // verify required parameter 'updateUserDetailsRequestDto' is not null or undefined
            assertParamExists('updateUserDetails', 'updateUserDetailsRequestDto', updateUserDetailsRequestDto)
            const localVarPath = `/api/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDetailsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign a role to the user or remove it
         * @param {string} userId 
         * @param {AssignUserRoleRequestDto} assignUserRoleRequestDto Role assignment request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignUserRole(userId: string, assignUserRoleRequestDto: AssignUserRoleRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignUserRole(userId, assignUserRoleRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.assignUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create user
         * @param {CreateUserRequestDto} createUserRequestDto Create user request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserRequestDto: CreateUserRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDetails(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDetails(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires ROLE_READ. The user\'s effective permissions are their role\'s permissions plus these grants. 404 codes: USER_NOT_FOUND.
         * @summary Get the additional permissions granted to the user on top of their role
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPermissionGrants(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPermissionGrantsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPermissionGrants(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserPermissionGrants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user short details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserShort(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserShortDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserShort(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserShort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get users short list
         * @param {PermissionDto} [permission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersShort(permission?: PermissionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserShortDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersShort(permission, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUsersShort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get my details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async me(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailsWithPermissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.me(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.me']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires ROLE_EDIT. The effective permissions change at once, without signing in again. 400 codes: PERMISSION_GRANTS_REQUIRED, PERMISSION_GRANT_UNKNOWN. 404 codes: USER_NOT_FOUND.
         * @summary Replace the additional permissions granted to the user on top of their role
         * @param {string} userId 
         * @param {ReplaceUserPermissionGrantsRequestDto} replaceUserPermissionGrantsRequestDto Additional permissions of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceUserPermissionGrants(userId: string, replaceUserPermissionGrantsRequestDto: ReplaceUserPermissionGrantsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPermissionGrantsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceUserPermissionGrants(userId, replaceUserPermissionGrantsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.replaceUserPermissionGrants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search users
         * @param {number} page 
         * @param {number} pageSize 
         * @param {UsersSearchRequestDto} usersSearchRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUsers(page: number, pageSize: number, usersSearchRequestDto: UsersSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUsers(page, pageSize, usersSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.searchUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user details
         * @param {string} userId 
         * @param {UpdateUserDetailsRequestDto} updateUserDetailsRequestDto User details update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserDetails(userId: string, updateUserDetailsRequestDto: UpdateUserDetailsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserDetails(userId, updateUserDetailsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign a role to the user or remove it
         * @param {string} userId 
         * @param {AssignUserRoleRequestDto} assignUserRoleRequestDto Role assignment request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUserRole(userId: string, assignUserRoleRequestDto: AssignUserRoleRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignUserRole(userId, assignUserRoleRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create user
         * @param {CreateUserRequestDto} createUserRequestDto Create user request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(createUserRequestDto: CreateUserRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createUser(createUserRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsDto> {
            return localVarFp.getUserDetails(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires ROLE_READ. The user\'s effective permissions are their role\'s permissions plus these grants. 404 codes: USER_NOT_FOUND.
         * @summary Get the additional permissions granted to the user on top of their role
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissionGrants(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserPermissionGrantsDto> {
            return localVarFp.getUserPermissionGrants(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user short details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShort(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserShortDto> {
            return localVarFp.getUserShort(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users short list
         * @param {PermissionDto} [permission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersShort(permission?: PermissionDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserShortDto>> {
            return localVarFp.getUsersShort(permission, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get my details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me(options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsWithPermissionDto> {
            return localVarFp.me(options).then((request) => request(axios, basePath));
        },
        /**
         * Requires ROLE_EDIT. The effective permissions change at once, without signing in again. 400 codes: PERMISSION_GRANTS_REQUIRED, PERMISSION_GRANT_UNKNOWN. 404 codes: USER_NOT_FOUND.
         * @summary Replace the additional permissions granted to the user on top of their role
         * @param {string} userId 
         * @param {ReplaceUserPermissionGrantsRequestDto} replaceUserPermissionGrantsRequestDto Additional permissions of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUserPermissionGrants(userId: string, replaceUserPermissionGrantsRequestDto: ReplaceUserPermissionGrantsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UserPermissionGrantsDto> {
            return localVarFp.replaceUserPermissionGrants(userId, replaceUserPermissionGrantsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search users
         * @param {number} page 
         * @param {number} pageSize 
         * @param {UsersSearchRequestDto} usersSearchRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers(page: number, pageSize: number, usersSearchRequestDto: UsersSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResponseDto> {
            return localVarFp.searchUsers(page, pageSize, usersSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user details
         * @param {string} userId 
         * @param {UpdateUserDetailsRequestDto} updateUserDetailsRequestDto User details update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails(userId: string, updateUserDetailsRequestDto: UpdateUserDetailsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserDetails(userId, updateUserDetailsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - interface
 */
export interface UsersApiInterface {
    /**
     * 
     * @summary Assign a role to the user or remove it
     * @param {string} userId 
     * @param {AssignUserRoleRequestDto} assignUserRoleRequestDto Role assignment request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignUserRole(userId: string, assignUserRoleRequestDto: AssignUserRoleRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Create user
     * @param {CreateUserRequestDto} createUserRequestDto Create user request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(createUserRequestDto: CreateUserRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get user details
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserDetails(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsDto>;

    /**
     * Requires ROLE_READ. The user\'s effective permissions are their role\'s permissions plus these grants. 404 codes: USER_NOT_FOUND.
     * @summary Get the additional permissions granted to the user on top of their role
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPermissionGrants(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserPermissionGrantsDto>;

    /**
     * 
     * @summary Get user short details
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserShort(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserShortDto>;

    /**
     * 
     * @summary Get users short list
     * @param {PermissionDto} [permission] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsersShort(permission?: PermissionDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserShortDto>>;

    /**
     * 
     * @summary Get my details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    me(options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsWithPermissionDto>;

    /**
     * Requires ROLE_EDIT. The effective permissions change at once, without signing in again. 400 codes: PERMISSION_GRANTS_REQUIRED, PERMISSION_GRANT_UNKNOWN. 404 codes: USER_NOT_FOUND.
     * @summary Replace the additional permissions granted to the user on top of their role
     * @param {string} userId 
     * @param {ReplaceUserPermissionGrantsRequestDto} replaceUserPermissionGrantsRequestDto Additional permissions of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    replaceUserPermissionGrants(userId: string, replaceUserPermissionGrantsRequestDto: ReplaceUserPermissionGrantsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UserPermissionGrantsDto>;

    /**
     * 
     * @summary Search users
     * @param {number} page 
     * @param {number} pageSize 
     * @param {UsersSearchRequestDto} usersSearchRequestDto Customer contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchUsers(page: number, pageSize: number, usersSearchRequestDto: UsersSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResponseDto>;

    /**
     * 
     * @summary Update user details
     * @param {string} userId 
     * @param {UpdateUserDetailsRequestDto} updateUserDetailsRequestDto User details update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserDetails(userId: string, updateUserDetailsRequestDto: UpdateUserDetailsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI implements UsersApiInterface {
    /**
     * 
     * @summary Assign a role to the user or remove it
     * @param {string} userId 
     * @param {AssignUserRoleRequestDto} assignUserRoleRequestDto Role assignment request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignUserRole(userId: string, assignUserRoleRequestDto: AssignUserRoleRequestDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).assignUserRole(userId, assignUserRoleRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create user
     * @param {CreateUserRequestDto} createUserRequestDto Create user request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUser(createUserRequestDto: CreateUserRequestDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).createUser(createUserRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user details
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserDetails(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserDetails(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires ROLE_READ. The user\'s effective permissions are their role\'s permissions plus these grants. 404 codes: USER_NOT_FOUND.
     * @summary Get the additional permissions granted to the user on top of their role
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserPermissionGrants(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserPermissionGrants(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user short details
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserShort(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserShort(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users short list
     * @param {PermissionDto} [permission] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersShort(permission?: PermissionDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersShort(permission, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get my details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public me(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).me(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires ROLE_EDIT. The effective permissions change at once, without signing in again. 400 codes: PERMISSION_GRANTS_REQUIRED, PERMISSION_GRANT_UNKNOWN. 404 codes: USER_NOT_FOUND.
     * @summary Replace the additional permissions granted to the user on top of their role
     * @param {string} userId 
     * @param {ReplaceUserPermissionGrantsRequestDto} replaceUserPermissionGrantsRequestDto Additional permissions of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public replaceUserPermissionGrants(userId: string, replaceUserPermissionGrantsRequestDto: ReplaceUserPermissionGrantsRequestDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).replaceUserPermissionGrants(userId, replaceUserPermissionGrantsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search users
     * @param {number} page 
     * @param {number} pageSize 
     * @param {UsersSearchRequestDto} usersSearchRequestDto Customer contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUsers(page: number, pageSize: number, usersSearchRequestDto: UsersSearchRequestDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).searchUsers(page, pageSize, usersSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user details
     * @param {string} userId 
     * @param {UpdateUserDetailsRequestDto} updateUserDetailsRequestDto User details update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserDetails(userId: string, updateUserDetailsRequestDto: UpdateUserDetailsRequestDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserDetails(userId, updateUserDetailsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

